import { createSelector } from "reselect"
import { getLatestDate, getEarliestDate } from "modules/portfolio-root/selectors/dates"
import { getBaseStartDate } from "modules/portfolio-root/selectors/base"
import { getViewType, getPeriod } from "modules/portfolio-root/selectors/portfolios"
import { getUnmodeledDates, getEndDate } from "selectors/dates"
import { getNextModeledDate, getStartDateWithBoundaries, getDatesAdjusted as getDatesAdjustedHelper, isUnmodeledDate } from "helpers/dates"
import { VIEW_TYPES } from "helpers/base"

export const getFetchStartDate = createSelector(
  [getEndDate, getPeriod, getEarliestDate, getLatestDate, getViewType, getBaseStartDate],
  (endDate, period, earliestDate, latestDate, viewType, baseStartDate) => {
    const startDate = getStartDateWithBoundaries(endDate, period, earliestDate, latestDate)
    if (viewType === VIEW_TYPES.ACTIVE && baseStartDate && startDate < baseStartDate) {
      return baseStartDate
    }

    return startDate
  },
)

export const getPerformanceFetchStartDate = createSelector(
  [getFetchStartDate, getBaseStartDate, getViewType, getUnmodeledDates, getLatestDate],
  (fetchStartDate, baseStartDate, viewType, unmodeledDates, latestDate) => {
    if (viewType === VIEW_TYPES.ACTIVE && baseStartDate && fetchStartDate <= baseStartDate) {
      return getNextModeledDate(baseStartDate, latestDate, unmodeledDates)
    }

    return fetchStartDate
  },
)

export const getFirstDate = createSelector(
  [getEarliestDate, getUnmodeledDates, getFetchStartDate, getPerformanceFetchStartDate, getLatestDate],
  (earliestDate, unmodeledDates, fetchStartDate, performanceFetchStartDate, latestDate) => {
    if (fetchStartDate < earliestDate) {
      return earliestDate
    }

    if (fetchStartDate < performanceFetchStartDate) {
      return performanceFetchStartDate
    }

    if (isUnmodeledDate(fetchStartDate, unmodeledDates)) {
      return getNextModeledDate(fetchStartDate, latestDate, unmodeledDates)
    }

    return fetchStartDate
  },
)

export const getDatesAdjusted = createSelector(
  [getPeriod, getFetchStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)
